export const collections = {
  "employees": {
    "name": "employees",
    "pascalName": "Employees",
    "tableName": "_content_employees",
    "source": [
      {
        "_resolved": true,
        "prefix": "/data/employees",
        "include": "data/employees/*.yaml",
        "cwd": "/vercel/path0/base/content"
      }
    ],
    "type": "data",
    "fields": {
      "id": "string",
      "description": "string",
      "extension": "string",
      "firstName": "string",
      "fullName": "string",
      "image": "string",
      "jobFunction": "string",
      "meta": "json",
      "stem": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "employees": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "fullName": {
              "type": "string"
            },
            "firstName": {
              "type": "string"
            },
            "jobFunction": {
              "type": "string"
            },
            "image": {
              "type": "string"
            },
            "description": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "fullName",
            "firstName",
            "jobFunction",
            "image",
            "description"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_employees (id TEXT PRIMARY KEY, \"description\" VARCHAR, \"extension\" VARCHAR, \"firstName\" VARCHAR, \"fullName\" VARCHAR, \"image\" VARCHAR, \"jobFunction\" VARCHAR, \"meta\" TEXT, \"stem\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  },
  "vacancies": {
    "name": "vacancies",
    "pascalName": "Vacancies",
    "tableName": "_content_vacancies",
    "source": [
      {
        "_resolved": true,
        "prefix": "/data/vacancies",
        "include": "data/vacancies/**/*.md",
        "cwd": "/vercel/path0/base/content"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "additionalSkillset": "json",
      "body": "json",
      "description": "string",
      "employmentType": "string",
      "extension": "string",
      "hours": "json",
      "level": "string",
      "location": "string",
      "meta": "json",
      "navigation": "json",
      "offer": "json",
      "organization": "string",
      "path": "string",
      "postingDate": "date",
      "salary": "json",
      "seo": "json",
      "shortDescription": "string",
      "skillset": "json",
      "startDate": "json",
      "stem": "string",
      "workHours": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "vacancies": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "type": "object",
              "properties": {
                "title": {
                  "type": "string"
                },
                "description": {
                  "type": "string"
                }
              },
              "required": [
                "title",
                "description"
              ],
              "additionalProperties": false
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string"
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            },
            "shortDescription": {
              "type": "string"
            },
            "location": {
              "type": "string"
            },
            "postingDate": {
              "type": "string",
              "format": "date-time"
            },
            "organization": {
              "type": "string",
              "enum": [
                "fit",
                "fysio"
              ]
            },
            "employmentType": {
              "type": "string",
              "enum": [
                "FULL_TIME",
                "PART_TIME",
                "CONTRACTOR",
                "TEMPORARY",
                "INTERN",
                "VOLUNTEER",
                "OTHER"
              ]
            },
            "startDate": {
              "anyOf": [
                {
                  "type": "string",
                  "const": "immediate"
                },
                {
                  "type": "string",
                  "format": "date-time"
                }
              ]
            },
            "salary": {
              "type": "object",
              "properties": {
                "unit": {
                  "type": "string",
                  "enum": [
                    "MONTH",
                    "HOUR"
                  ]
                },
                "from": {
                  "type": "number"
                },
                "till": {
                  "type": "number"
                }
              },
              "required": [
                "unit",
                "from"
              ],
              "additionalProperties": false
            },
            "hours": {
              "type": "object",
              "properties": {
                "from": {
                  "type": "number"
                },
                "till": {
                  "type": "number"
                }
              },
              "required": [
                "from",
                "till"
              ],
              "additionalProperties": false
            },
            "level": {
              "type": "string"
            },
            "skillset": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "additionalSkillset": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "offer": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "workHours": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "description",
            "body",
            "shortDescription",
            "location",
            "postingDate",
            "organization",
            "employmentType",
            "startDate",
            "salary",
            "hours",
            "level",
            "skillset",
            "additionalSkillset",
            "offer",
            "seo"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_vacancies (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"additionalSkillset\" TEXT, \"body\" TEXT, \"description\" VARCHAR, \"employmentType\" VARCHAR, \"extension\" VARCHAR, \"hours\" TEXT, \"level\" VARCHAR, \"location\" VARCHAR, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"offer\" TEXT, \"organization\" VARCHAR, \"path\" VARCHAR, \"postingDate\" DATE, \"salary\" TEXT, \"seo\" TEXT, \"shortDescription\" VARCHAR, \"skillset\" TEXT, \"startDate\" TEXT, \"stem\" VARCHAR, \"workHours\" VARCHAR NULL, \"__hash__\" TEXT UNIQUE);"
  },
  "content": {
    "name": "content",
    "pascalName": "Content",
    "tableName": "_content_content",
    "source": [
      {
        "_resolved": true,
        "prefix": "/",
        "include": "**/*.md",
        "cwd": "/vercel/path0/fysio/content"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "content": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string"
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "description",
            "body"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_content (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"body\" TEXT, \"description\" VARCHAR, \"extension\" VARCHAR, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"path\" VARCHAR, \"seo\" TEXT DEFAULT '{}', \"stem\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  },
  "therapyServices": {
    "name": "therapyServices",
    "pascalName": "TherapyServices",
    "tableName": "_content_therapyServices",
    "source": [
      {
        "_resolved": true,
        "prefix": "/data/physical-therapy",
        "include": "data/physical-therapy/**/*.yaml",
        "cwd": "/vercel/path0/fysio/content"
      }
    ],
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "price": "number",
      "stem": "string",
      "url": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "therapyServices": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "name": {
              "type": "string"
            },
            "price": {
              "type": "number"
            },
            "url": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "name",
            "price"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_therapyServices (id TEXT PRIMARY KEY, \"extension\" VARCHAR, \"meta\" TEXT, \"name\" VARCHAR, \"price\" INT, \"stem\" VARCHAR, \"url\" VARCHAR NULL, \"__hash__\" TEXT UNIQUE);"
  },
  "info": {
    "name": "info",
    "pascalName": "Info",
    "tableName": "_content_info",
    "source": [],
    "type": "data",
    "fields": {},
    "schema": {
      "$ref": "#/definitions/info",
      "definitions": {},
      "$schema": "http://json-schema.org/draft-07/schema#"
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_info (id TEXT PRIMARY KEY, \"ready\" BOOLEAN, \"structureVersion\" VARCHAR, \"version\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  }
}
export const gitInfo = {
  "name": "fysio-hier-website",
  "owner": "Syourt",
  "url": "https://github.com/Syourt/fysio-hier-website"
}
export const appConfigSchema = {}